import React from 'react';

import { useCompanyCountryExposure } from '~/hooks/use-knowledge-graph/useKnowledgeGraph';

import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';

export interface CountryExposureTabProps {
  entityTag: string;
}

export const CountryExposureTab = ({ entityTag }: CountryExposureTabProps) => {
  const { openCountry } = useGeographicDrawer();

  const { data, isFetching } = useCompanyCountryExposure({
    entityTag: entityTag,
    enabled: !!entityTag,
  });

  return (
    <GeographicExposureTable
      mode="country"
      data={data}
      isFetching={isFetching}
      onRowClick={openCountry}
    />
  );
};
